import React from 'react';

import { Button } from '@alfalab/core-components/button';

import { HelpDeskModal } from '../help-desk-modal';

import styles from './footer.module.css';

export const Footer = () => (
    <div className={styles.footer}>
        <HelpDeskModal />
        <Button view='link' href='https://alfabank.ru/apps/apeople/' size='xxs'>
            Скачать мобильное приложение
        </Button>
    </div>
);
